module.exports = __webpack_public_path__ + "img/germany-skin-connective-and-musculoskeletal-diseases-female.b9527a5f.png";